<template>
    <div class="w-lab-recommendations" v-if="products.length">
        <div class="alert">
            <div>
                <w-alert-circle class="circle" :status="status"/>
            </div>
            {{ $t("lab.suggestedProducts") }}
        </div>

        <ul v-if="products.length">
            <li v-for="item in products" :key="item.id">{{ item.name }}</li>
        </ul>
        <div class="add-to-cart" v-if="products.length">
            <div class="d-flex align-items-end">
                <!-- No content, keeping to move the button to the right -->
            </div>
            <div>
                <w-button type="circle" size="lg" class="yummo-bold" @click="go(link)">
                    {{ $t('button.buy') }}
                </w-button>
            </div>
        </div>
    </div>
</template>

<script>
import {GA_ADD_TO_CART, GA_VIEW_ITEM} from "../../app/src/constants/ga_events";

export default {
    name: "Recommendations",
    props: {
        status: {
            type: String,
            default: 'RED'
        },
        link: {
            type: String,
            required: true
        },
        products: {
            type: Array,
            default: () => []
        },
        outdated: {
            type: Boolean,
            default: false
        }
    },
    mounted(){
        this.$gtag.event(GA_VIEW_ITEM, {
            currency: "USD",
            value: this.products.reduce((total, { price }) => total + price, 0),
            items: this.products.map(product => ({
                    item_id: product.sku,
                    item_name: product.name,
                    quantity: 1,
                    currency: 'USD',
                    price: product.price,
                })
            )
        })
    },
    methods: {
        go (link) {
            if (this.$route.name === 'home'){
                this.$gtag.event('Add to cart - home screen');
            }

            if (this.$route.name === 'lab-results'){
                this.$gtag.event('Add to cart - WG TEST advice');
            }

            this.$gtag.event(GA_ADD_TO_CART, {
                currency: "USD",
                value: this.products.reduce((total, { price }) => total + price, 0),
                items: this.products.map(product => ({
                        item_id: product.sku,
                        item_name: product.name,
                        quantity: 1,
                        currency: 'USD',
                        price: product.price,
                    })
                )
            })

            location.href = link
        }
    }
}
</script>

<style scoped>
    .btn.test {
        line-height: 24px;
        font-size: 24px;
    }
</style>
